/**
 * Supabase client singleton.
 *
 * Reads environment variables (Vite-prefixed for browser
 * exposure), validates their presence, and creates a
 * single Supabase client instance. The anon key is used
 * only — the service role key is never imported here.
 */

import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import { env } from '@/lib/env';

let client: SupabaseClient | null = null;

export function getSupabase(): SupabaseClient {
  if (!client) {
    env.validate();
    client = createClient(env.supabaseUrl, env.supabaseAnonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    });
  }
  return client;
}

export type { SupabaseClient };
